import { notify } from "./notification";
import lighthouse from "@lighthouse-web3/sdk";
import bs58 from "bs58";
import axios from "axios";
import { baseUrl } from "../config/urls";

let publicAddress: string | undefined;
declare const window: any;

export const  getProvider = (): any | undefined => {
  const isPhantomInstalled = (window as any).phantom?.solana?.isPhantom
  if (isPhantomInstalled) {
    const provider:any = window.phantom?.solana;
    if (provider?.isPhantom) {
      return provider;
    } 
  }else {
    notify(`Phantom wallet not installed`, "error");
    return undefined;
  }
};

export const connectWallet = async (): Promise<string | undefined> => {
  const isPhantomInstalled = (window as any).phantom?.solana?.isPhantom

  if (isPhantomInstalled) {
    try {
      const { solana } = (window as any).phantom
      const response = await solana.connect();
      publicAddress = response.publicKey.toString();
      return response.publicKey.toString();
    } catch (err: any) {
      if (err?.code === 4001) {
        notify(`Access Denied`, "error");
      }
    }
  }else{
    notify(`Please Install Phantom Wallet`,'error');
  }
};

export const getDecryptKey = async (
  cid: string
): Promise<string | any> => {
  const publicKey:string = await connectWallet() || '';
  const signed_message = await solana_sign_auth_message();
  const key = await lighthouse.fetchEncryptionKey(
    cid,
    publicKey,
    signed_message
  );
  return key?.data?.key;
};

export const decryptEncryptedFileSolana = async (cid: string): Promise<any> => {
  const key = await getDecryptKey(cid);
  const decrypted = await lighthouse.decryptFile(cid, key);
  return decrypted;
};

export const solana_sign_auth_message = async (): Promise<string> => {
  const publicAddress:string = await connectWallet() || '';
  const provider = await getProvider()
  const messageRequested = await lighthouse.getAuthMessage(publicAddress);
  const encodedMessage = new TextEncoder().encode(
    messageRequested?.data?.message || ''
  );
  const signedMessage = await provider.signMessage(encodedMessage, "utf8");
 

  return bs58.encode(signedMessage?.signature);
};

export const solana_sign_message = async (): Promise<{
  message: string;
  signed_message: string;
  address: string | undefined;
  alternativeAddress: string | undefined;
}> => {
  await connectWallet();
  const res = await axios.get(
    `${baseUrl}/api/auth/get_message?publicKey=${publicAddress}&encryption=true`
  );
  const message = res.data;
  const encodedMessage = new TextEncoder().encode(message);
  const { signature } = await window.solana.signMessage(
    encodedMessage
  );
  return {
    message: message,
    signed_message: bs58.encode(signature), // Use bs58.encode here
    address: publicAddress,
    alternativeAddress: publicAddress
  };
};
